import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Link } from '@material-ui/core';
import { Loader } from '../Loading';
import { FormattedMessage } from 'react-intl';

/**
 * Product view
 * Displays the product name and description, 
 * along with a "learn more" link to the product URL
 */

const NEWLINE = "\n";

const styles = theme => ({
  media: {
    height: 160,
    backgroundColor: theme.palette.primary.main,
    backgroundSize: 'auto'
  },
  image: {
    maxHeight: 200,
    maxWidth: 250,
  },
  container: {
    display: 'flex',
    flexDirection:'column',
    marginTop: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },
  link: {
    marginLeft: 4,
  },
  description: {
    marginTop: 24,
    display: 'flex',
    flexDirection:'column',
    alignItems: 'center'
  },
  defaultText: {
    color: '#797979',
    fontWeight: 300
  },
});

const ProductPageDescription = ({ classes, product}) => (
  product? 
    <div className={classes.container}>
      <div className={classes.textBlock}>   
      <Typography variant="h4" className={classes.defaultText}>
        <FormattedMessage 
          id="product.title.whatIs" 
          values={{
            productName: product.name
          }}
        />
      </Typography>
      </div>
      <div className={classes.description} >
        {
          product.description && product.description
            .split(NEWLINE)
            .map((line, i) => {
              const lineCount= product.description.split(NEWLINE).length;
              if (i === lineCount-1){
                const withLinkToProduct = 
                  <div key={i} style={{display:'flex', flexDirection:'row'}}>
                    <Typography variant="subtitle1" component="p" key={i}>{line}</Typography>
                    {product.url &&
                      <Link
                        underline= "none"
                        variant="subtitle1"
                        className={classes.link}
                        href={product.learnMoreUrl}
                        target="_blank"
                        rel="noopener"
                      >
                        <FormattedMessage id='product.button.learnMore' />
                      </Link>
                    }
                  </div>
                return withLinkToProduct
              } else {
                return <Typography variant="subtitle1" component="p" key={i}>{line}</Typography>
              }
            } 
          )
        }  
      </div> 
    </div> 
    : <Loader />
);

ProductPageDescription.propTypes = {
  product: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(
  ProductPageDescription
);


// WEBPACK FOOTER //
// ./src/components/products/ProductPageDescription.js